import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectFilter = ({ 
  categories, 
  technologies, 
  selectedCategory, 
  selectedTechnology, 
  onCategoryChange, 
  onTechnologyChange,
  onClearFilters,
  projectCount 
}) => {
  return (
    <div className="bg-card rounded-xl p-6 shadow-elegant mb-8">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        {/* Filter Header */}
        <div className="flex items-center space-x-3">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Filter Projects</h3>
          <span className="px-3 py-1 bg-primary/10 text-primary text-sm rounded-full">
            {projectCount} projects
          </span>
        </div>

        {/* Clear Filters */}
        {(selectedCategory !== 'All' || selectedTechnology !== 'All') && (
          <Button
            variant="ghost"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            className="text-muted-foreground hover:text-foreground"
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        {/* Category Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Project Category
          </label>
          <div className="flex flex-wrap gap-2">
            {categories?.map((category) => (
              <button
                key={category}
                onClick={() => onCategoryChange(category)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-primary text-white shadow-md'
                    : 'bg-muted text-muted-foreground hover:bg-primary/10 hover:text-primary'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Technology Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Technology Stack
          </label>
          <div className="flex flex-wrap gap-2">
            {technologies?.map((tech) => (
              <button
                key={tech}
                onClick={() => onTechnologyChange(tech)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  selectedTechnology === tech
                    ? 'bg-accent text-secondary shadow-md'
                    : 'bg-muted text-muted-foreground hover:bg-accent/10 hover:text-accent'
                }`}
              >
                {tech}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectFilter;